import { render, staticRenderFns } from "./TownsDropdown.vue?vue&type=template&id=60872977&"
import script from "./TownsDropdown.vue?vue&type=script&lang=js&"
export * from "./TownsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports